<template>
    <div>
        <div class="shaizi" :class="{ 'shaizi-animation': isDiceAnimation, 'shaizi-breath': !isDiceAnimation }"
            :style="{ transform: shaizExistTransformStyle }" ref="shaizDom">
            <div class="face">
                <div class="item_1"></div>
            </div>
            <div class="face">
                <div class="item_2"></div>
                <div class="item_2"></div>
            </div>
            <div class="face">
                <div class="item_3"></div>
                <div class="item_3"></div>
                <div class="item_3"></div>
            </div>
            <div class="face">
                <div class="face_0">
                    <div class="item_4"></div>
                    <div class="item_4"></div>
                </div>
                <div class="face_0">
                    <div class="item_4"></div>
                    <div class="item_4"></div>
                </div>
            </div>
            <div class="face">
                <div class="face_0">
                    <div class="item_5"></div>
                    <div class="item_5"></div>
                </div>
                <div class="face_0">
                    <div class="item_5"></div>
                </div>
                <div class="face_0">
                    <div class="item_5"></div>
                    <div class="item_5"></div>
                </div>
            </div>
            <div class="face">
                <div class="face_0">
                    <div class="item_6"></div>
                    <div class="item_6"></div>
                </div>
                <div class="face_0">
                    <div class="item_6"></div>
                    <div class="item_6"></div>
                </div>
                <div class="face_0">
                    <div class="item_6"></div>
                    <div class="item_6"></div>
                </div>
            </div>
        </div>
        <!-- <div class="shezhi" v-if="shezhi">
            <div class="recur" @click="recur"></div>
            <div class="end" @click="quit"></div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'Dice',
    props: {
        isDice: false,
        diceResult:Number
    },
    data() {
        return {
            resultValue: '',
            isDiceAnimation: false,
            possibility: [
                { value: 1, x: 45, y: 0, z: -45 },
                { value: 2, x: 135, y: -45, z: 0 },
                { value: 3, x: -45, y: -45, z: -90 },
                { value: 4, x: 135, y: 45, z: -90 },
                { value: 5, x: -45, y: 45, z: 0 },
                { value: 6, x: 45, y: 180, z: -45 },
            ],
            // shezhi: false,
            // const emit = defineEmits(['refgain','quits'])
            // 可能出现的情况集合
            shaizExistTransformStyle: "rotateX(45deg) rotateY(0deg) rotateZ(-45deg)"

        }
    },
    mounted() {
        this.onAnimationEnd()
        setTimeout(() => {
            // this.isDiceAnimation = this.isDice;
            this.isDiceAnimation = true;
        }, 0);
    },
    methods: {
        async onAnimationEnd() {
            this.$refs.shaizDom.addEventListener('webkitAnimationEnd', () => {
                console.log("onAnimationEnd-act")
                // 准备抽取的随机数、抽取的随机结果
                // let random = Math.floor(Math.random() * 6),

                   let result = this.possibility[this.diceResult -1 ]
                // 浏览器反应不过来加过渡
                setTimeout(() => {
                    // 让骰子旋转到正确的角度,更改动画属性，以待下一次动画的正常执行
                    this.shaizExistTransformStyle = `rotateX(${result.x}deg) rotateY(${result.y}deg) rotateZ(${result.z}deg`
                    this.isDiceAnimation = false;
                    this.resultValue = result;
                    // setTimeout(() => {
                    //     this.shezhi = true;
                    // }, 2000)


                    // emit('refgain')
                    this.$emit('refgain');
                    // 通知父组件，抽取结果
                }, 0);

            })
        },
        // recur() {
        //     setTimeout(() => {
        //         this.shezhi = false;
        //         this.isDiceAnimation = true;
        //         // emit('refgain')
        //     }, 0);
        // },
        // quit() {
        //     this.$emit('quits');
        // }
    },

}
</script>

<style scoped lang="less">
// .shezhi {
//     width: 50rem;
//     height: 100px;
//     margin-top: 100px;
//     display: inline-block;

//     div {
//         display: inline-block;
//     }

//     .recur {
//         width: 200px;
//         height: 100px;
//         background-image: url('../../../assets/imgs/Summer/again-btn.png');
//     }

//     .end {
//         width: 200px;
//         height: 100px;
//         background-image: url('../../../assets/imgs/Summer/end-btn.png');
//         float: right;
//     }
// }

@keyframes rotate {
    from {
        transform: rotateX(0) rotateY(0) rotateZ(0);
    }

    to {
        transform: rotateX(1turn) rotateY(1turn) rotateZ(0);
    }

}

@keyframes breath {
    to {
        scale: 1.2;
    }
}

.shaizi {
    width: 120px;
    height: 120px;
    margin: 50px auto;
    position: relative;
    transform-style: preserve-3d;
    // transition: all 1s;
}

.shaizi-animation {
    animation: rotate 1s linear 0s 5 normal;
    animation-duration: 500ms;

}

.shaizi-breath {
    animation: breath .5s linear 0s infinite alternate;
    animation-duration: 2s;
}

.shaizi .face {
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid rgba(0, 0, 0, 0.5);
    background: rgb(253, 250, 250);
    border-radius: 20px;
    font-size: 100px;
    color: #fff;
    line-height: 300px;
    text-align: center;
}

.item_1 {
    width: 40px;
    height: 40px;
    background: rgba(240, 54, 54, 0.9);
    border-radius: 50%;
}

.item_2 {
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 50%;
}

.item_3 {
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 50%;
}

.item_4 {
    width: 30px;
    height: 30px;
    background: rgba(240, 54, 54, 0.9);
    border-radius: 50%;
}

.item_5 {
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 50%;
}

.item_6 {
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 50%;
}

.face:nth-child(1) {
    justify-content: center;
    align-items: center;
    transform: translateZ(60px);
}

.face:nth-child(2) {
    justify-content: space-around;
    align-items: center;
    transform: rotateX(-90deg) translateZ(60px);
}

.face:nth-child(3) {
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    transform: rotateY(90deg) translateZ(60px);
}

.face:nth-child(4) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    transform: rotateY(-90deg) translateZ(60px);
}

.face:nth-child(4) .face_0 {
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: space-around;
}

.face:nth-child(5) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    transform: rotateX(90deg) translateZ(60px);
}

.face:nth-child(5) .face_0 {
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: space-around;
}

.face:nth-child(6) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    transform: translateZ(-60px);
}

.face:nth-child(6) .face_0 {
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: space-around;
}

p {
    text-align: center;
}

p {
    text-align: center;
}
</style>